"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const material_1 = require("@mui/material");
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const lodash_1 = require("lodash");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../../helper");
const notification_1 = __importDefault(require("../../../constants/notification"));
const URL = helper_1.URLS.app;
const FooterComponent = (props) => {
    const { subject, message, users, validate, onCallback, roundId, onModalClose, } = props;
    const onSubmitNotification = async () => {
        if (!!subject && !!message) {
            // get list id user notify
            const notifyUsers = users
                .filter((user) => {
                return user === null || user === void 0 ? void 0 : user.selected;
            })
                .map((user) => {
                return user === null || user === void 0 ? void 0 : user.id;
            });
            if (notifyUsers.length > 0) {
                if (onCallback) {
                    await onCallback();
                }
                utilities_1.default.blockPage();
                await pulse_components_1.v2Endpoint
                    .request({
                    method: pulse_components_1.METHODS.POST,
                    url: `${URL}api/rounds/${roundId}/reviewers/notify`,
                    data: {
                        subject,
                        message,
                        user_ids: notifyUsers,
                    },
                    headers: {
                        'Content-Type': 'application/vnd.api+json',
                        Accept: 'application/vnd.api+json',
                    },
                })
                    .then(() => {
                    utilities_1.default.unblockPage();
                    utilities_1.default.notification.success(typeof notification_1.default.sentMailReviewer !== 'string' &&
                        notification_1.default.sentMailReviewer(notifyUsers.length));
                    if ((0, lodash_1.isFunction)(onModalClose))
                        onModalClose();
                });
            }
            else {
                utilities_1.default.notification.danger(notification_1.default.requireSelectReviewer);
            }
        }
        else {
            validate(subject, message);
            utilities_1.default.notification.danger(notification_1.default.requireEmailMessage);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Divider, { light: true }),
        react_1.default.createElement("div", { className: styles_modules_less_1.default['footer-component__root'] },
            react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default['add-timesheet__submit--button']], icon: true, iconClasses: { icon: 'fal fa-envelope' }, label: "Notify selected reviewers", color: pulse_components_1.Colors.success, onClick: onSubmitNotification }))));
};
exports.default = FooterComponent;
